import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getTravelPlansContent,
  transformPlanDetailsForModal,
} from "../../../api/contentServices";
import closeicon from "../../../assets/images/close.svg";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import BackdropModal from "../../common/modal/backdropModal";
import BenefitRow from "./BenefitRow";

// Fallback data in case API fails
const fallbackBenefitsData = [
  {
    label: "Emergency Medical Expenses Abroad",
    label_ar: "مصاريف العلاج الطبي الطارئ في الخارج",
    values: ["€40,000", "$500,000", "$1,000,000"],
  },
  {
    label: "Emergency Medical Expenses Abroad due to Covid-19",
    label_ar: "مصاريف العلاج الطبي الطارئ في الخارج بسبب فيروس كوفيد-19",
    values: ["€35,000", "$35,000", "$50,000"],
  },
  {
    label: "Emergency Medical Evacuation",
    label_ar: "إجلاء طبي طارئ",
    values: ["€40,000", "$100,000", "$1,000,000"],
  },
  {
    label: "Emergency Medical Repatriation",
    label_ar: "إعادة ترحيل طبي طارئ",
    values: ["€40,000", "$100,000", "$1,000,000"],
  },
  {
    label: "Emergency Dental Care",
    label_ar: "رعاية طبية طارئة للأسنان",
    values: ["€1,000", "$1,500", "$3,000"],
  },
  {
    label: "Repatriation of Mortal Remains",
    label_ar: "إعادة ترحيل جثامين الأموات",
    values: ["€40,000", "$50,000", "$1,000,000"],
  },
  {
    label: "Convalescence expenses",
    label_ar: "مصاريف التعافي",
    values: ["€500", "$1,000", "$1,500"],
  },
  {
    label: "Return of Minor Children",
    label_ar: "إعادة ترحيل الأطفال الصغار",
    values: ["€500", "$1,000", "$3,000"],
  },
  {
    label: "Emergency return home following death of an immediate family member",
    label_ar: "عودة طارئة للمنزل بعد وفاة أحد أفراد العائلة المباشرة",
    values: ["€2,000", "$2,500", "$5,000"],
  },
  {
    label: "Repatriation of immediate family member travelling with the Beneficiary",
    label_ar: "إعادة ترحيل أحد أفراد العائلة المباشرة الذي يسافر مع المستفيد",
    values: ["€2,000", "$10,000", "$10,000"],
  },
  {
    label: "Compassionate Visit",
    label_ar: "زيارة رحيمة",
    values: ["€500", "$1,500", "$3,000"],
  },
  {
    label: "Delivery of Medicines",
    label_ar: "توصيل الأدوية",
    values: ["❌", "$1,000", "$5,000"],
  },
  {
    label: "24 Hours Travel information service",
    label_ar: "خدمة معلومات السفر على مدار الساعة",
    values: ["✅", "✅", "✅"],
  },
  {
    label: "Advance of bail bond",
    label_ar: "تقديم تأمين للكفالة",
    values: ["€500", "$10,000", "$10,000"],
  },
  {
    label: "Legal Assistance",
    label_ar: "المساعدة القانونية",
    values: ["❌", "$4,000", "$10,000"],
  },
  {
    label: "Mugging",
    label_ar: "السطو المسلح",
    values: ["❌", "$500", "$1,000"],
  },
  {
    label: "Hijacking",
    label_ar: "الاختطاف",
    values: ["❌", "❌", "$15,000"],
  },
  {
    label: "Trip cancellation abroad",
    label_ar: "إلغاء الرحلة في الخارج",
    values: ["€2,500", "$6,000", "$8,000"],
  },
  {
    label: "Loss of passport, driving license, national identity card",
    label_ar: "فقدان جواز السفر، رخصة القيادة، أو بطاقة الهوية الوطنية",
    values: ["€500", "$1,000", "$2,000"],
  },
  {
    label: "Total loss of checked-in baggage (up to 60 kgs)",
    label_ar: "فقدان كامل للأمتعة المسجلة (حتى ٦٠ كيلوجرام)",
    values: [
      { en: "€20 per KGRS", ar: "٢٠ يورو لكل كجم" },
      { en: "$45 per KGRS", ar: "٤٥ دولار لكل كجم" },
      { en: "$125 per KGRS", ar: "١٢٥ دولار لكل كجم" },
    ],
  },
  {
    label: "Delay in the arrival of checked-in baggage (over 4 hours)",
    label_ar: "تأخير في وصول الأمتعة المسجلة (أكثر من ٤ ساعات)",
    values: ["€500", "$1,000", "$1,500"],
  },
  {
    label: "Stolen or Damaged Luggage",
    label_ar: "سرقة أو تلف الأمتعة",
    values: ["❌", "$500", "$1,000"],
  },
  {
    label: "Personal Money",
    label_ar: "المبلغ النقدي الشخصي",
    values: ["€250", "$1,500", "$2,500"],
  },
  {
    label: "Personal Electronic",
    label_ar: "الأجهزة الإلكترونية الشخصية",
    values: ["€250", "$500", "$750"],
  },
  {
    label: "Location and forwarding of personal effects",
    label_ar: "تحديد موقع وإعادة توجيه الأغراض الشخصية",
    values: ["✅", "✅", "✅"],
  },
  {
    label: "Flight Delay (Delayed departure over 4 hours)",
    label_ar: "تأخر الرحلة (تأخر المغادرة أكثر من ٤ ساعات)",
    values: ["€150", "$1,000", "$1,500"],
  },
  {
    label: "Flight overbooking",
    label_ar: "حجز زائد للرحلة",
    values: ["❌", "$250", "$500"],
  },
  {
    label: "Loss of credit Card",
    label_ar: "فقدان بطاقة الائتمان",
    values: ["€500", "$5,000", "$5,000"],
  },
  {
    label: "Death in common carrier",
    label_ar: "وفاة في وسيلة نقل عامة",
    values: ["€30,000", "$50,000", "$150,000"],
  },
  {
    label: "Permanent partial disability",
    label_ar: "إعاقة جزئية دائمة (نِسبة من المبلغ الأساسي وفقًا للمقياس)",
    values: [
      "❌",
      {
        en: "% of principal sum as per scale",
        ar: "% من المبلغ الأساسي حسب المقياس",
      },
      {
        en: "% of principal sum as per scale",
        ar: "% من المبلغ الأساسي حسب المقياس",
      },
    ],
  },
  {
    label: "Permanent total disability",
    label_ar: "إعاقة كلية دائمة",
    values: ["❌", "$50,000", "$150,000"],
  },
  {
    label: "Personal Civil Liability",
    label_ar: "المسؤولية المدنية الشخصية",
    values: ["€150,000", "$500,000", "$1,000,000"],
  },
];

const TravelBenefitsModal = ({ show, onClose, plans }) => {
  const translate = useLanguageTranslate();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.resolvedLanguage || "en";

  const [benefitsData, setBenefitsData] = useState(fallbackBenefitsData);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Mobile tab navigation states
  const [selectedPlanTab, setSelectedPlanTab] = useState("worldwide_ex"); // Default to Worldwide excluding US/Canada
  const [selectedSubTab, setSelectedSubTab] = useState("benefits"); // benefits or covers

  // Helper function to get circle color
  const getCircleColor = (planId) => {
    switch (planId) {
      case "schengen":
        return "#B0BABF";
      case "worldwide_ex":
        return "#F8DD4E";
      case "worldwide":
        return "#55C6EF";
      default:
        return "#B0BABF";
    }
  };

  // Helper function to get plan index for mobile display
  const getSelectedPlanIndex = () => {
    switch (selectedPlanTab) {
      case "schengen":
        return 0;
      case "worldwide_ex":
        return 1;
      case "worldwide":
        return 2;
      default:
        return 1;
    }
  };

  // Fetch travel plans content from API
  useEffect(() => {
    const fetchPlansContent = async () => {
      setLoading(true);
      setError(null);

      try {
        console.log("Fetching travel plans content for modal...");
        const response = await getTravelPlansContent();

        if (response.success && response.data?.planDetails) {
          console.log("✅ Travel plans content fetched successfully");
          const transformedData = transformPlanDetailsForModal(
            response.data.planDetails,
            currentLanguage
          );
          setBenefitsData(transformedData);
        } else {
          console.warn(
            "⚠️ Failed to fetch travel plans content, using fallback data"
          );
          setError(response.error);
          setBenefitsData(fallbackBenefitsData);
        }
      } catch (err) {
        console.error("❌ Error fetching travel plans content:", err);
        setError(err.message);
        setBenefitsData(fallbackBenefitsData);
      } finally {
        setLoading(false);
      }
    };

    if (show) {
      fetchPlansContent();
    }
  }, [show, currentLanguage]);

  if (!show) return null;

  return (
    <BackdropModal show={show} onClose={onClose} hideClosebtn>
      <div className="-mx-6 max767:-mx-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-4 -mt-6 max767:mb-6 px-6">
          <h2 className="text-[#1A2024] text-2xl font-medium max767:text-lg">
            {translate(
              "Plans full list of benefits & covers",
              "قائمة كاملة بالمزايا والتغطيات"
            )}
          </h2>
          <button
            onClick={onClose}
            className="p-2 bg-gray-100 rounded-full"
          >
            <img src={closeicon} alt="Close" className="w-6 h-6" />
          </button>
        </div>

        {/* Mobile Plan Tabs - Only visible on mobile */}
        <div className="hidden max767:flex w-full">
          {plans.map((plan, index) => {
            const isActive = selectedPlanTab === plan.id;
            const isFirst = index === 0;
            const isLast = index === plans.length - 1;

            return (
              <button
                key={plan.id}
                onClick={() => setSelectedPlanTab(plan.id)}
                className={`relative flex flex-col items-center justify-center gap-2 pb-3 pt-3 flex-1 transition-all border-b border-[#DDE2E4] ${
                  isActive ? "bg-[#F6F8F9]" : ""
                } ${!isFirst ? "border-l border-l-[#DDE2E4]" : ""} ${
                  !isLast ? "border-r border-r-[#DDE2E4]" : ""
                }`}
              >
                {plan.imgSrc ? (
                  <img
                    src={plan.imgSrc}
                    alt=""
                    className="w-[18px] h-[18px] object-contain"
                  />
                ) : (
                  <div
                    className="w-[18px] h-[18px] rounded-full"
                    style={{ backgroundColor: getCircleColor(plan.id) }}
                  />
                )}
                <span
                  className={`text-sm ${
                    isActive
                      ? "text-[#00719A] font-semibold"
                      : "text-[#48535B] font-normal"
                  }`}
                >
                  {translate(plan.name, plan.name_ar)}
                  {plan.subtitle && (
                    <span className="block text-[10px] font-normal leading-3">
                      {translate(plan.subtitle, plan.subtitle_ar)}
                    </span>
                  )}
                </span>
                {/* Active indicator - 90% width */}
                {isActive && (
                  <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[90%] h-[3px] bg-[#00719A]"></div>
                )}
              </button>
            );
          })}
        </div>

        <div className="w-full max-h-[80vh] overflow-y-auto relative max767:max-h-[65vh]">
          {/* Benefits Table */}
          <table className="w-full border-collapse max767:table-fixed">
            <thead>
              {/* Desktop Table Header - Show all plans */}
              <tr className="sticky top-0 z-10 max767:hidden">
                <th className="text-left rtl:text-right py-[24px] text-lg px-[20px] text-[#252C32] font-semibold bg-[#F6F8F9]">
                  {translate("Benefits", "الفوائد")}
                </th>
                {plans.map((plan) => {
                  return (
                    <th
                      key={plan.id}
                      className="text-center py-[24px] px-[20px] text-[#252C32] text-lg font-semibold min-w-[120px] bg-[#F6F8F9]"
                    >
                      <div className="flex items-center justify-center gap-2">
                        {plan.imgSrc ? (
                          <img
                            src={plan.imgSrc}
                            alt=""
                            className="w-[18px] h-[18px] object-contain"
                          />
                        ) : (
                          <div
                            className="w-[18px] h-[18px] rounded-full"
                            style={{ backgroundColor: getCircleColor(plan.id) }}
                          />
                        )}
                        <span>
                          {translate(plan.name, plan.name_ar)}
                          {plan.subtitle && (
                            <span className="block text-[10px] font-normal leading-3">
                              {translate(plan.subtitle, plan.subtitle_ar)}
                            </span>
                          )}
                        </span>
                      </div>
                    </th>
                  );
                })}
              </tr>

              {/* Mobile Table Header - Benefits and Covers */}
              <tr className="hidden max767:table-row sticky top-0 z-10 bg-[#F6F8F9]">
                <th className="text-left rtl:text-right py-[24px] px-[20px] text-[#252C32] font-semibold text-sm">
                  {translate("Benefits", "الفوائد")}
                </th>
                <th className="text-right py-[24px] px-[20px] text-[#252C32] font-semibold text-sm">
                  {translate("Covers", "التغطيات")}
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan={plans.length + 1}
                    className="py-[24px] px-[20px] text-center"
                  >
                    <div className="flex flex-col items-center gap-4">
                      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#00384D]"></div>
                      <p className="text-[#5B6871]">
                        {translate(
                          "Loading benefits...",
                          "جاري تحميل المزايا..."
                        )}
                      </p>
                    </div>
                  </td>
                </tr>
              ) : benefitsData.length === 0 ? (
                <tr>
                  <td
                    colSpan={plans.length + 1}
                    className="py-[24px] px-[20px] text-center text-[#5B6871]"
                  >
                    {translate(
                      "No benefits data available",
                      "لا توجد بيانات مزايا متاحة"
                    )}
                  </td>
                </tr>
              ) : (
                benefitsData.map((benefit, index) => (
                  <BenefitRow
                    key={index}
                    benefit={benefit}
                    plans={plans}
                    selectedPlanIndex={getSelectedPlanIndex()}
                  />
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </BackdropModal>
  );
};

export default TravelBenefitsModal;
